import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import apple from '../../images/apple.png';
import tomato from '../../images/tomato-ben.png';
import peach from '../../images/peach-ben.png';
import prones from '../../images/prones-ben.png';
import avacado from '../../images/avacado-ben.png';
import './TheBenefits.css';

function TheBenefits() {
    return (
        <section>
            <div className="benefits-bg">

                <Container fluid>
                    <Row className='ben-col-op'>
                        <Col lg={5} md={12} sm={12}>
                            <div className='ben-left-div'>
                                <h1>The Benefits</h1>
                                <h3>to Retailers, Wholesellers and the <br />
                                    Entire Supply Chain</h3>
                            </div>
                        </Col>
                        <Col lg={7} md={12} sm={12}>
                            <div className='ben-right-div'>
                                <div className="ben-row">
                                    <div className="ben-left-col">
                                        <img src={apple} alt="Apple" />
                                    </div>
                                    <div className="ben-right-col">
                                        <p className='ben-bold-text'>Maximixing produce value</p>
                                        <ul>
                                            <li>Products sent to customers or channels where there is a
                                                best fit in terms of quality, price and shelf life</li>
                                            <li>Losses are minimized</li>
                                            <li>Operations are optimized (transportation, storage, ripening,
                                                packaging)</li>
                                            <li>Nutritional values are maintained</li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="ben-row-2">
                                    <div className="ben-left-col">
                                        <img src={tomato} alt="Tomato" />
                                    </div>
                                    <div className="ben-right-col">
                                        <p>
                                            <span className='ben-bold-text'>Maximizing profitability:</span>
                                            before produce quality degradation
                                            becomes visible, retailers can offer dynamic pricing
                                        </p>
                                    </div>
                                </div>

                                <div className="ben-row-3">
                                    <div className="ben-left-col third-fruit">
                                        <img src={peach} alt="Peach" />
                                    </div>
                                    <div className="ben-right-col">
                                        <p>
                                            <span className='ben-bold-text'>Minimizing stock issues:</span>
                                            the platform can accurately predict
                                            shelf life, increasing the chances that planned stock is always
                                            available
                                        </p>
                                    </div>
                                </div>

                                <div className="ben-row-4">
                                    <div className="ben-left-col fourth-fruit">
                                        <img src={prones} alt="Prones" />
                                    </div>
                                    <div className="ben-right-col">
                                        <p>
                                            <span className='ben-bold-text'>Driving commitment from supply chain:</span>
                                            creating long term
                                            engagements with the supply chain and ensuring the flow of
                                            data to benefit all stakeholders
                                        </p>
                                    </div>
                                </div>

                                <div className="ben-row-5">
                                    <div className="ben-left-col fifth-fruit">
                                        <img src={avacado} alt="Avacado" />
                                    </div>
                                    <div className="ben-right-col">
                                        <p>
                                            <span className='ben-bold-text'>Improving company image:</span>
                                            image is associated with quality
                                            and freshness, plus improved social and sustainable practices
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </section>
    )
}

export default TheBenefits
